var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00007 7.42642V13C7.00007 13.5555 7.44464 14 8.00007 14C8.5555 14 9.00007 13.5555 9.00007 13V7.42642L12.3916 2H3.60857L7.00007 7.42642ZM1.45239 2.32371C0.826294 1.32196 0.710425 0 2.00007 0L14.0001 0C15.2901 0 15.1734 1.3227 14.5501 2.32L11.0001 8.00002V13C11.0001 14.66 9.66007 16 8.00007 16C6.34007 16 5.00007 14.66 5.00007 13V8.00002L1.45239 2.32371Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.1568c736aa5c17422925f81b444e16fc.svg";
export { ForwardRef as ReactComponent };